import { render, staticRenderFns } from "./r-fly-button.vue?vue&type=template&id=a0d36562"
import script from "./r-fly-button.vue?vue&type=script&lang=js"
export * from "./r-fly-button.vue?vue&type=script&lang=js"
import style0 from "./r-fly-button.vue?vue&type=style&index=0&id=a0d36562&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports